/**
 * Porté depuis apps/web/app/(shop)/faq/page.tsx (page statique, aucune
 * adaptation nécessaire au-delà de l'abandon de `generateMetadata`, hors
 * périmètre — cf. lot SEO/prérendu séparé).
 */
interface FaqItem {
  question: string;
  answer: string;
}

// Réponses limitées à ce qui est réellement implémenté (VVS_MODELE_INTERFACE.md,
// `apps/api/src/notification/` vide à ce lot) : pas de promesse d'email/SMS de
// confirmation automatique, pas de page de suivi de commande en self-service —
// ces canaux n'existent pas côté API pour l'instant.
const FAQ_ITEMS: FaqItem[] = [
  {
    question: "Comment passer une commande sur VVS ?",
    answer:
      "Parcourez les rayons ou utilisez la recherche, ajoutez vos articles au panier, renseignez votre commune de livraison pour connaître les frais exacts, puis validez votre commande. Un conseiller vous appelle ensuite pour la confirmer avant expédition.",
  },
  {
    question: "Quels sont les moyens de paiement disponibles ?",
    answer:
      "Deux modes de paiement sont proposés : le paiement à la livraison (en espèces, au livreur) et le mobile money. Le paiement par carte bancaire en ligne n'est pas disponible pour le moment.",
  },
  {
    question: "Dans quelles villes VVS livre-t-il ?",
    answer:
      "VVS livre à Abidjan et dans les grandes villes de Côte d'Ivoire. La disponibilité pour votre commune exacte est confirmée au moment de la commande.",
  },
  {
    question: "Quels sont les délais et frais de livraison ?",
    answer:
      "À Abidjan, la livraison s'effectue généralement sous 24 heures après confirmation de la commande. Les frais de livraison dépendent de votre commune : ils sont calculés et affichés dans le tunnel de commande avant que vous ne validiez votre achat.",
  },
  {
    question: "Vais-je recevoir un email ou un SMS pour confirmer ma commande ?",
    answer:
      "Aucun email ni SMS automatique de confirmation de commande n'est envoyé à ce jour. La confirmation se fait par un appel téléphonique d'un conseiller, avant l'expédition de votre commande. Un email vous est en revanche envoyé lors de la création de votre compte ou de la connexion, pour vérifier votre identité (code de vérification).",
  },
  {
    question: "Comment suivre l'état de ma commande ?",
    answer:
      "Après validation, votre commande reçoit un numéro qui s'affiche sur la page de confirmation. Pour toute question sur son statut, contactez notre équipe sur WhatsApp en indiquant ce numéro.",
  },
  {
    question: "Puis-je vérifier mon article avant de payer ?",
    answer:
      "Oui, si vous choisissez le paiement à la livraison : vous pouvez vérifier l'article devant le livreur avant de régler.",
  },
  {
    question: "Comment retourner un article ?",
    answer:
      "Un article présentant un défaut peut être signalé dans un délai raisonnable après réception, via WhatsApp, en précisant votre numéro de commande. Les conditions détaillées sont présentées sur la page Retours.",
  },
  {
    question: "Faut-il un compte pour commander sur VVS ?",
    answer:
      "Un compte VVS vous permet de retrouver vos informations et de gérer votre panier plus facilement. L'inscription se fait avec votre numéro de téléphone et votre adresse email : un code de vérification vous est envoyé par email pour confirmer votre identité.",
  },
  {
    question: "Comment contacter VVS en cas de question ?",
    answer:
      "Le moyen le plus rapide est WhatsApp : voir la page Contact pour le lien direct vers la conversation.",
  },
];

export function FaqPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Foire aux questions</h1>
      <p className="mt-2 max-w-prose font-body text-sm text-muted">
        Les réponses aux questions les plus courantes sur la commande, le paiement, la livraison
        et les retours.
      </p>

      <div className="mt-6 max-w-prose space-y-3">
        {FAQ_ITEMS.map((item) => (
          <details key={item.question} className="group rounded-sm border border-line bg-white p-4">
            <summary className="cursor-pointer list-none font-display text-sm font-semibold text-navy [&::-webkit-details-marker]:hidden">
              <span className="inline-flex w-full items-center justify-between gap-2">
                {item.question}
                <span aria-hidden="true" className="text-gold transition-transform group-open:rotate-180">
                  ▾
                </span>
              </span>
            </summary>
            <p className="mt-3 font-body text-sm leading-relaxed text-muted">{item.answer}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
